import React, { useEffect, useState } from "react";
import { X, Loader2, Check, ImageOff } from "lucide-react";
import api from "../api";

export const MediaLibrary = ({ open, multi, onClose, onSelect }) => {
  const [items, setItems] = useState(null);
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    if (open) {
      setSelected([]);
      setItems(null);
      api.get("/admin/media").then((r) => setItems(r.data)).catch(() => setItems([]));
    }
  }, [open]);

  if (!open) return null;

  const toggle = (url) => {
    if (!multi) {
      onSelect([url]);
      return;
    }
    setSelected((s) => (s.includes(url) ? s.filter((u) => u !== url) : [...s, url]));
  };

  return (
    <div className="fixed inset-0 z-[80] bg-black/80 flex items-center justify-center p-4" data-testid="media-library-modal">
      <div className="bg-[#111] border border-[var(--border)] w-full max-w-4xl max-h-[85vh] flex flex-col">
        <div className="flex items-center justify-between p-4 border-b border-[var(--border)]">
          <h3 className="text-white text-sm tracking-widest uppercase">
            Fotoğraf Kütüphanesi {items ? `(${items.length})` : ""}
          </h3>
          <button onClick={onClose} className="text-white/60 hover:text-white" data-testid="media-library-close">
            <X size={20} />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-4">
          {!items ? (
            <div className="flex items-center justify-center py-16 text-white/50">
              <Loader2 size={24} className="animate-spin" />
            </div>
          ) : items.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-16 text-white/40 gap-3">
              <ImageOff size={32} />
              <p className="text-sm">Kütüphanede fotoğraf yok</p>
            </div>
          ) : (
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
              {items.map((it) => {
                const sel = selected.includes(it.url);
                return (
                  <button
                    type="button"
                    key={it.public_id}
                    onClick={() => toggle(it.url)}
                    className={`relative group border-2 ${sel ? "border-white" : "border-transparent hover:border-white/40"}`}
                    data-testid={`media-item-${it.public_id.split("/").pop()}`}
                  >
                    <img src={it.thumb} alt="" loading="lazy" className="w-full aspect-[4/3] object-cover" />
                    {sel && (
                      <div className="absolute top-2 right-2 bg-white text-black rounded-full p-1">
                        <Check size={14} />
                      </div>
                    )}
                  </button>
                );
              })}
            </div>
          )}
        </div>
        {multi && (
          <div className="p-4 border-t border-[var(--border)] flex justify-end gap-3">
            <button onClick={onClose} className="btn-sharp text-white !py-2.5 !px-4 !text-xs" data-testid="media-library-cancel">
              Vazgeç
            </button>
            <button
              onClick={() => selected.length && onSelect(selected)}
              disabled={!selected.length}
              className="btn-sharp btn-primary !py-2.5 !px-4 !text-xs disabled:opacity-40"
              data-testid="media-library-add"
            >
              {selected.length} Görsel Ekle
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
